var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServerError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "server-error_svg__a",
    x1: "100%",
    x2: "0%",
    y1: "46.716%",
    y2: "53.801%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BDBBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9E9BAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "server-error_svg__b",
    x1: "100%",
    x2: "0%",
    y1: "42.499%",
    y2: "58.681%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BDBBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9E9BAC"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h200v200H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 2)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#3C3C3C",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M75 0v100h20V20.453"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 11,
    x: 70,
    y: 99,
    fill: "#FFF",
    stroke: "#3C3C3C",
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 11,
    x: 66,
    y: 110,
    fill: "url(#server-error_svg__a)",
    stroke: "#3C3C3C",
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#3C3C3C",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M70 152h32v31a2 2 0 01-2 2H72a2 2 0 01-2-2v-31h0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M75.5 176v9m5-9v9m6-9v9m5-9v9m5-9v9"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 41,
    x: 62,
    y: 120,
    fill: "#FFF",
    stroke: "#3C3C3C",
    strokeWidth: 2,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#3C3C3C",
    strokeWidth: 2,
    transform: "translate(70 131)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 3.5,
    r: 3.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#server-error_svg__b)",
    d: "M8 12h16v1a6 6 0 01-6 6h-4a6 6 0 01-6-6v-1h0z",
    transform: "matrix(1 0 0 -1 0 31)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#3C3C3C",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M84.5 38v50"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 125.5,
    r: 2.5,
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 192.5,
    r: 3.5,
    fill: "#FFF",
    stroke: "#3C3C3C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 152,
    r: 6,
    fill: "#FFF",
    stroke: "#3C3C3C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#3C3C3C",
    strokeWidth: 2,
    d: "M17.5 79C23.299 79 28 83.701 28 89.5c0 .168-.004.335-.012.5H28a5 5 0 014.584 3H0a7 7 0 017.589-6.976C9.023 81.934 12.919 79 17.5 79zm135-54c-8.008 0-14.5 6.716-14.5 15v.071A7.002 7.002 0 00130.29 45h45.697a9.5 9.5 0 00-9.811-9.995C164.187 29.176 158.816 25 152.5 25z"
  })))));
}
export default SvgServerError;